export const getApproximatedValue = (value: number) => {
	const fixedValue = +value.toFixed(2);
	return fixedValue % 1 === 0 ? fixedValue : fixedValue.toFixed(2);
};
